module.exports = __webpack_public_path__ + "static/media/arts_16.7699f716.jpg";